import script from "./MatchingPairsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MatchingPairsCard.vue?vue&type=script&setup=true&lang=js"

import "./MatchingPairsCard.vue?vue&type=style&index=0&id=6f5772f1&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f5772f1"]])

export default __exports__